export const waitForAnimationEnd = (node) => new Promise((resolve) => {
    node.addEventListener('transitionend', resolve, {
        once: true,
    });
    setTimeout(resolve, 500);
});
//# sourceMappingURL=comment-box.utils.js.map